import React from 'react';
import { useAcademy } from '../../../context/Academy';
import { useAcademyHub } from '../../../context/AcademyHub';
import { Button } from '../../ui/Button';
import { inputClass } from '../../ui/Field';
import { timeAgo } from '../../../utils/academyFormat';

/** The admin side of the support chat. Every learner message is also emailed to hello@cavalladata.com. */
export function AdminSupport() {
  const {
    state
  } = useAcademy();
  const {
    hub,
    replyAsSupport
  } = useAcademyHub();
  const [draft, setDraft] = React.useState('');
  const messages = hub.chat.filter(m => m.from !== 'system');
  if (!messages.length) {
    return <p className="rounded-md border border-dashed border-line px-5 py-8 text-center text-[14px] text-muted" data-id="element-293" data-mp="2e2zogn3vmluk">
        No open conversations. Messages from the support chat appear here and are emailed to hello@cavalladata.com.
      </p>;
  }
  const last = messages[messages.length - 1];
  return <div className="grid gap-8 lg:grid-cols-[260px_1fr]" data-id="element-294" data-mp="oo1vtq01mb41">
      <div className="rounded-md border border-gold/60 bg-panel p-4" data-id="element-295" data-mp="2lor2khv8g8gn">
        <p className="text-[14px] text-ink" data-id="element-296" data-mp="2lq26qislbi8a">{state.learner?.name ?? 'Guest'}</p>
        <p className="text-small text-muted" data-id="element-297" data-mp="2gw7o7ioq19as">{state.learner?.email ?? 'No email yet'}</p>
        <p className="mt-2 text-small text-royal" data-id="element-298" data-mp="2byz0z3opuf2o">{last.from === 'learner' ? 'Waiting for reply' : 'Replied'} · {timeAgo(last.at)}</p>
      </div>
      <div data-id="element-299" data-mp="34muyubq0ud11">
        <ol className="max-h-[420px] space-y-3 overflow-y-auto rounded-md border border-line p-4" aria-live="polite" data-id="element-300" data-mp="34nmt9j7vu4pq">
          {messages.map(m => <li key={m.id} className={`flex ${m.from === 'support' ? 'justify-end' : 'justify-start'}`} data-id="element-301" data-mp="2zlxg9y13ngz0">
              <p className={`max-w-[80%] rounded-md px-3.5 py-2.5 text-[14px] ${m.from === 'support' ? 'bg-gold text-charcoal' : 'bg-panel text-ink'}`} data-id="element-302" data-mp="2ur078r3tl7m4">
                {m.body}
              </p>
            </li>)}
        </ol>
        <form onSubmit={e => {
        e.preventDefault();
        if (!draft.trim()) return;
        replyAsSupport(draft);
        setDraft('');
      }} className="mt-3 flex gap-2" data-id="element-303" data-mp="1f7ne9lhl1l26">
          <label htmlFor="support-reply" className="sr-only" data-id="element-304" data-mp="1lnx0jlkpb58j">Reply</label>
          <input id="support-reply" value={draft} onChange={e => setDraft(e.target.value)} placeholder="Reply as the Academy team" className={inputClass} data-id="element-305" data-mp="16rxt8d5f194g" />
          <Button type="submit" disabled={!draft.trim()} data-id="element-306" data-mp="1bs2f6ip3ew22">Send</Button>
        </form>
      </div>
    </div>;
}